import React from "react";
import ProductsAccordion from "./components/ProductsAccordion";
import { Divider, Segment } from "semantic-ui-react";
import InvoiceDetails from "./components/InvoiceDetails";
// import DiscountCodeForm from "./components/DiscountCodeForm";
const CheckoutInvoice = ({
  step,
  total,
  subtotal,
  formInfo,
  customizationCost,
  shippingCost,
  setCurrency,
  totalUSD,
  usdSubTotal
}) => {
  return (
    <Segment>
      <ProductsAccordion />
      <Divider />
      {/* <DiscountCodeForm />
      <Divider /> */}
      <InvoiceDetails
        step={step}
        total={total}
        subtotal={subtotal}
        formInfo={formInfo}
        customizationCost={customizationCost}
        shippingCost={shippingCost}
        setCurrency={setCurrency}
        totalUSD={totalUSD}
        usdSubTotal={usdSubTotal}
      />
    </Segment>
  );
};
export default CheckoutInvoice;
